import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { OperationFilter } from '../../shared/operation-filter';

@Injectable({
  providedIn: 'root'
})
export class OperationConfirmationService {

  filters: BehaviorSubject<OperationFilter> = new BehaviorSubject({} as OperationFilter);

}
